import { render, staticRenderFns } from "./addCommentDialog.vue?vue&type=template&id=ca00b3fe&scoped=true"
import script from "./addCommentDialog.vue?vue&type=script&lang=ts"
export * from "./addCommentDialog.vue?vue&type=script&lang=ts"
import style0 from "./addCommentDialog.vue?vue&type=style&index=0&id=ca00b3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca00b3fe",
  null
  
)

export default component.exports